"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var detect_browser_1 = require("detect-browser");
var DefaultBrowserBehavior = /*#__PURE__*/function () {
  function DefaultBrowserBehavior() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$recreateAudioCon = _ref.recreateAudioContextIfNeeded,
      recreateAudioContextIfNeeded = _ref$recreateAudioCon === void 0 ? false : _ref$recreateAudioCon;
    _classCallCheck(this, DefaultBrowserBehavior);
    this.browser = detect_browser_1.detect();
    this.browserSupport = {
      chrome: 78,
      'edge-chromium': 79,
      electron: 7,
      firefox: 75,
      ios: 12,
      safari: 12,
      opera: 66,
      samsung: 12,
      crios: 86,
      fxios: 23,
      'ios-webview': 605,
      'chromium-webview': 92
    };
    this.browserName = {
      chrome: 'Google Chrome',
      'edge-chromium': 'Microsoft Edge',
      electron: 'Electron',
      firefox: 'Mozilla Firefox',
      ios: 'Safari iOS',
      safari: 'Safari',
      opera: 'Opera',
      samsung: 'Samsung Internet',
      crios: 'Chrome iOS',
      fxios: 'Firefox iOS',
      'ios-webview': 'WKWebView iOS',
      'chromium-webview': 'Chrome WebView'
    };
    this.chromeLike = ['chrome', 'edge-chromium', 'chromium-webview', 'opera', 'samsung'];
    this.webkitBrowsers = ['crios', 'fxios', 'safari', 'ios', 'ios-webview'];
    this.recreateAudioContextIfNeeded = recreateAudioContextIfNeeded;
  }
  _createClass(DefaultBrowserBehavior, [{
    key: "version",
    value: function version() {
      return this.browser.version;
    }
  }, {
    key: "majorVersion",
    value: function majorVersion() {
      return parseInt(this.version().split('.')[0]);
    }
  }, {
    key: "name",
    value: function name() {
      return this.browser.name;
    }
  }, {
    key: "hasChromiumWebRTC",
    value: function hasChromiumWebRTC() {
      var _iterator = _createForOfIteratorHelper(this.chromeLike),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var browser = _step.value;
          if (browser === this.browser.name) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "hasWebKitWebRTC",
    value: function hasWebKitWebRTC() {
      var _iterator2 = _createForOfIteratorHelper(this.webkitBrowsers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var browser = _step2.value;
          if (browser === this.browser.name) {
            return true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }, {
    key: "hasFirefoxWebRTC",
    value: function hasFirefoxWebRTC() {
      return this.isFirefox();
    }
  }, {
    key: "supportsCanvasCapturedStreamPlayback",
    value: function supportsCanvasCapturedStreamPlayback() {
      return !this.isIOSSafari() && !this.isIOSChrome() && !this.isIOSFirefox();
    }
  }, {
    key: "supportsBackgroundFilter",
    value: function supportsBackgroundFilter() {
      // disable Safari 15
      // see: https://github.com/aws/amazon-chime-sdk-js/issues/1059
      if (this.name() === 'safari' && this.majorVersion() === 15) {
        return false;
      }
      if (!this.supportsCanvasCapturedStreamPlayback()) {
        return false;
      }
      return true;
    }
  }, {
    key: "requiresUnifiedPlan",
    value: function requiresUnifiedPlan() {
      return this.isFirefox() || this.hasChromiumWebRTC() || this.hasWebKitWebRTC() && this.isUnifiedPlanSupported();
    }
  }, {
    key: "requiresResolutionAlignment",
    value: function requiresResolutionAlignment(width, height) {
      if (this.isAndroid() && this.isPixel3()) {
        return [Math.ceil(width / 64) * 64, Math.ceil(height / 64) * 64];
      }
      return [width, height];
    }
  }, {
    key: "requiresCheckForSdpConnectionAttributes",
    value: function requiresCheckForSdpConnectionAttributes() {
      return !this.isIOSSafari() && !this.isIOSChrome() && !this.isIOSFirefox();
    }
  }, {
    key: "requiresIceCandidateGatheringTimeoutWorkaround",
    value: function requiresIceCandidateGatheringTimeoutWorkaround() {
      return this.hasChromiumWebRTC();
    }
  }, {
    key: "requiresUnifiedPlanMunging",
    value: function requiresUnifiedPlanMunging() {
      return this.hasChromiumWebRTC() || this.hasWebKitWebRTC() && this.isUnifiedPlanSupported();
    }
  }, {
    key: "requiresSortCodecPreferencesForSdpAnswer",
    value: function requiresSortCodecPreferencesForSdpAnswer() {
      return this.isFirefox() && this.majorVersion() <= 68;
    }
  }, {
    key: "requiresSimulcastMunging",
    value: function requiresSimulcastMunging() {
      return this.isSafari();
    }
  }, {
    key: "requiresBundlePolicy",
    value: function requiresBundlePolicy() {
      return 'max-bundle';
    }
  }, {
    key: "requiresPromiseBasedWebRTCGetStats",
    value: function requiresPromiseBasedWebRTCGetStats() {
      return !this.hasChromiumWebRTC();
    }
  }, {
    key: "requiresVideoElementWorkaround",
    value: function requiresVideoElementWorkaround() {
      return this.isSafari() && this.majorVersion() === 12;
    }
  }, {
    key: "requiresNoExactMediaStreamConstraints",
    value: function requiresNoExactMediaStreamConstraints() {
      return this.isSamsungInternet() || this.isIOSSafari() && (this.version() === '12.0.0' || this.version() === '12.1.0');
    }
  }, {
    key: "requiresGroupIdMediaStreamConstraints",
    value: function requiresGroupIdMediaStreamConstraints() {
      return this.isSamsungInternet();
    }
  }, {
    key: "requiresContextRecreationForAudioWorklet",
    value: function requiresContextRecreationForAudioWorklet() {
      if (!this.recreateAudioContextIfNeeded) {
        return false;
      }
      // Definitely not Chrome; no worries.
      if (!('chrome' in global)) {
        return false;
      }
      // Everything seems to work fine on platforms other than macOS.
      if (this.browser.os !== 'Mac OS') {
        return false;
      }
      // Electron or Chromium.
      // All other browsers are fine. But you'd have to be super weird --
      // faking global.chrome but not having a Chrome UA -- to get this far,
      // so we have some Istanbul directives on these.
      /* istanbul ignore else */
      if (this.isChrome() || this.isEdge()) {
        return true;
      }
      /* istanbul ignore next */
      return false;
    }
  }, {
    key: "getDisplayMediaAudioCaptureSupport",
    value: function getDisplayMediaAudioCaptureSupport() {
      return this.isChrome() || this.isEdge();
    }
  }, {
    key: "supportsSenderSideBandwidthEstimation",
    value: function supportsSenderSideBandwidthEstimation() {
      return this.hasChromiumWebRTC() || this.isSafari();
    } // There's a issue in Chormium WebView that causes enumerate devices to return empty labels, this is a check for this issue.
    // https://bugs.chromium.org/p/chromium/issues/detail?id=669492
  }, {
    key: "doesNotSupportMediaDeviceLabels",
    value: function doesNotSupportMediaDeviceLabels() {
      return this.browser.name === 'chromium-webview';
    } // TODO: Deprecated, needs to be removed
  }, {
    key: "screenShareUnsupported",
    value: function screenShareUnsupported() {
      console.warn('This function is no longer supported.');
      return true;
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      if (!this.browserSupport[this.browser.name] || this.majorVersion() < this.browserSupport[this.browser.name]) {
        return false;
      }
      if (this.browser.name === 'firefox' && this.isAndroid()) {
        return false;
      }
      return true;
    }
  }, {
    key: "isSimulcastSupported",
    value: function isSimulcastSupported() {
      return this.hasChromiumWebRTC();
    }
  }, {
    key: "supportDownlinkBandwidthEstimation",
    value: function supportDownlinkBandwidthEstimation() {
      return !this.isFirefox();
    }
  }, {
    key: "supportString",
    value: function supportString() {
      if (this.isAndroid()) {
        return "".concat(this.browserName['chrome'], " ").concat(this.browserSupport['chrome'], "+, ").concat(this.browserName['samsung'], " ").concat(this.browserSupport['samsung'], "+");
      }
      var s = [];
      for (var k in this.browserSupport) {
        s.push("".concat(this.browserName[k], " ").concat(this.browserSupport[k], "+"));
      }
      return s.join(', ');
    }
  }, {
    key: "supportedVideoCodecs",
    value: function supportedVideoCodecs() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var pc;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pc = new RTCPeerConnection();
              pc.addTransceiver('video', {
                direction: 'inactive',
                streams: []
              });
              _context.next = 4;
              return pc.createOffer({
                offerToReceiveVideo: true
              });
            case 4:
              return _context.abrupt("return", _context.sent.sdp.split('\r\n').filter(function (x) {
                return x.includes('a=rtpmap:');
              }).map(function (x) {
                return x.replace(/.* /, '').replace(/\/.*/, '');
              }).filter(function (v, i, a) {
                return a.indexOf(v) === i;
              }).filter(function (x) {
                return x !== 'rtx' && x !== 'red' && x !== 'ulpfec';
              }));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "supportsSetSinkId",
    value: function supportsSetSinkId() {
      return 'setSinkId' in HTMLAudioElement.prototype;
    }
  }, {
    key: "disableResolutionScaleDown",
    value: function disableResolutionScaleDown() {
      return this.isAndroid();
    }
  }, {
    key: "disable480pResolutionScaleDown",
    value: function disable480pResolutionScaleDown() {
      return /( Chrome\/98\.)/i.test(navigator.userAgent) && this.browser.os.startsWith('Windows');
    }
  }, {
    key: "requiresDisablingH264Encoding",
    value: function requiresDisablingH264Encoding() {
      return (this.isIOSSafari() || this.isIOSChrome() || this.isIOSFirefox()) && (this.version() === '15.1.0' || /( OS 15_1)/i.test(navigator.userAgent));
    } // These helpers should be kept private to encourage
    // feature detection instead of browser detection.
  }, {
    key: "isIOSSafari",
    value: function isIOSSafari() {
      return this.browser.name === 'ios' || this.browser.name === 'ios-webview' || this.browser.name === 'safari' && /( Mac )/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1 //Ipad
      ;
    }
  }, {
    key: "isSafari",
    value: function isSafari() {
      return this.browser.name === 'safari' || this.browser.name === 'ios';
    }
  }, {
    key: "isFirefox",
    value: function isFirefox() {
      return this.browser.name === 'firefox';
    }
  }, {
    key: "isIOSFirefox",
    value: function isIOSFirefox() {
      return this.browser.name === 'fxios';
    }
  }, {
    key: "isIOSChrome",
    value: function isIOSChrome() {
      return this.browser.name === 'crios';
    }
  }, {
    key: "isChrome",
    value: function isChrome() {
      return this.browser.name === 'chrome';
    }
  }, {
    key: "isEdge",
    value: function isEdge() {
      return this.browser.name === 'edge-chromium';
    }
  }, {
    key: "isSamsungInternet",
    value: function isSamsungInternet() {
      return this.browser.name === 'samsung';
    }
  }, {
    key: "isAndroid",
    value: function isAndroid() {
      return /(android)/i.test(navigator.userAgent);
    }
  }, {
    key: "isPixel3",
    value: function isPixel3() {
      return /( pixel 3)/i.test(navigator.userAgent);
    }
  }, {
    key: "isUnifiedPlanSupported",
    value: function isUnifiedPlanSupported() {
      return RTCRtpTransceiver.prototype.hasOwnProperty('currentDirection');
    }
  }]);
  return DefaultBrowserBehavior;
}();
exports.default = DefaultBrowserBehavior;